import React, { useState } from 'react'
import AddNewAssessment from './drawer/addNewAssessment'
import { Col, Row } from 'antd'
import AssessmentComponent from './assessmentListComponent'

const AssessmentList = ({ user }) => {
  const [assessmentProfileDrawer, setAssessmentProfileDrawer] = useState({
    visible: false,
    assessmentData: {}
  })
  const [showTable, setShowTable] = useState(true)
  const [reloadTable, setReloadTable] = useState(false)

  const events = {
    showDrawer: (data) => {
      setAssessmentProfileDrawer({ visible: true, assessmentData: data })
    },
    hideDrawer: () => {
      setAssessmentProfileDrawer({ visible: false, assessmentData: {} })
    }
  }

  return (
    <>
      {showTable ? (
        <>
          <div className='table-head d-flex align-items-start justify-content-between'>
            <div className={'ass-card-left'}>
              <h2 className='welcome-heading'>
                Welcome, <br />
                <span className={'colorPrimaryDark'}>{user.companyName}</span>
              </h2>
              <div className={'mt10'}>
                <a className='submit-assessment-btn'
                   onClick={() => events.showDrawer()}>
                  Start New Assessment
                </a>
              </div>
            </div>
            <div className='d-flex align-items-center'>
              <div className={'ass-small-card'}>
                <img src='../images/leftImage.png' className='assessment1-bofore'
                     style={{ height: 60, marginRight: 20, marginTop: 0 }} />
              </div>
              <img src='../images/topAssessment.png' className='assessmentImage' style={{ height: 130 }} />
            </div>
          </div>
          <div className='card'>
            <AssessmentComponent
              callBack={(value) => {
                setShowTable(value)
              }}
              header={false}
              reloadTable={reloadTable}
            />
          </div>
        </>
      ) : (
        <Row className='assessmentImageContainer'>
          <Col md={12}>
            <div>
              <h2 className='welcome-heading-before'>
                Welcome, <br />
                <span style={{ color: '#0b35ae' }}>Ryan Consultants</span>
              </h2>
              <img src='/images/leftImage.png' className='assessment1-bofore' />
              <button
                className='submit-assessment-btn-before'
                onClick={() => events.showDrawer()}
              >
                Start New Assessment
              </button>
            </div>
          </Col>
          <Col md={12}>
            <div className='assessmentImageContainer'>
              <img src='/images/topAssessment.png' className='assessmentImage' />
            </div>
          </Col>
        </Row>
      )}

      {assessmentProfileDrawer.visible && (
        <AddNewAssessment
          {...assessmentProfileDrawer}
          onClose={() => {
            events.hideDrawer()
          }}
          onSubmit={() => {
            setShowTable(true)
            setReloadTable(true)
          }}
        />
      )}

    </>
  )
}

export default AssessmentList
